import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_USER_DUPLICATES = gql`
query getUserDuplicates($userId: String!) {
  getUserDuplicates(userId: $userId) {
    isAuth
    subscriptionElsewhere
    matches {
      _id
      pairId
      email
      createdAt
      socialnetwork
      roles
      holdsSubscription
      subscriptionLastDate
      reasons
    }
  }
}
`;

const getUserDuplicates = async (variables) => {
  try {
    const result = await client.query({
      query: GET_USER_DUPLICATES,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getUserDuplicates: duplicatesData } } = result;

    if (duplicatesData) {
      return duplicatesData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getUserDuplicates = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getUserDuplicates Error: ${error}`);
    return null;
  }
};

export default getUserDuplicates;
